import { writable } from 'svelte/store';
export function bodyLock(_, condition = writable(true)) {
    condition.subscribe((value) => {
        if (value) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.removeProperty('overflow');
        }
    });
    return {
        destroy() {
            document.body.style.removeProperty('overflow');
        }
    };
}
